/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Education } from '../../models/education';

export interface CreateEducation$Params {
  profileId: string;
      body?: Education
}

export function createEducation(http: HttpClient, rootUrl: string, params: CreateEducation$Params, context?: HttpContext): Observable<StrictHttpResponse<Education>> {
  const rb = new RequestBuilder(rootUrl, createEducation.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Education>;
    })
  );
}

createEducation.PATH = '/studentprofile/{profileId}/education';
